<axs-sheet #mobileSheetRef
           class="mobile-inputs-sheet"
           >
  <div slot="title" class="mobile-inputs-sheet__title-wrapper">
    <h1 class="text-title-2">{{ headerTitle }}</h1>
    <p class="mobile-inputs-sheet__description" [innerHTML]="description"></p>
  </div>
  <div slot="content" class="mobile-inputs-sheet__content">
    <div *ngIf="showAppliedSampleClientBanner" class="mobile-inputs-sheet__sample-client-banner" aria-live="polite">
      <img
        src="assets/svgs/check.svg"
        alt=""
        aria-hidden="true"
        class="mobile-inputs-sheet__sample-client-banner-icon"
      />
      <span class="mobile-inputs-sheet__sample-client-banner-text text-body-6">
        {{ sampleClientBannerPrefix }} {{ appliedSampleClientTitle }}
      </span>
    </div>

    <!-- Client tax information section -->
    <div class="mobile-inputs-sheet__section">
      <div class="mobile-inputs-sheet__section-header">
        <img src="assets/images/Icon v2.svg" alt="" class="mobile-inputs-sheet__section-icon" />
        <span class="mobile-inputs-sheet__section-title">{{ clientTaxTitle }}</span>
      </div>
      <client-tax-info (infoIconClicked)="onInfoIcon($event)"></client-tax-info>
    </div>

    <!-- Roth conversion details section -->
    <div class="mobile-inputs-sheet__section">
      <div class="mobile-inputs-sheet__section-header">
        <img src="assets/images/roth-conv.svg" alt="" class="mobile-inputs-sheet__section-icon" />
        <span class="mobile-inputs-sheet__section-title">{{ rothConvTitle }}</span>
      </div>
      <roth-conv-details (infoIconClicked)="onInfoIcon($event)"></roth-conv-details>
    </div>
  </div>

  <div slot="bottom" class="mobile-inputs-sheet__bottom">
    <button
      type="button"
      class="mobile-inputs-sheet__bottom-button"
      (click)="onUpdate()">
      {{ updateButtonText }}
    </button>
  </div>
</axs-sheet>
